export default __webpack_public_path__ + "static/media/graphic-11.47f6be5a.png";